export default "__VITE_ASSET__746bc1fb__"